export const en = {
    heading: 'We will set up your first campaign in Yandex.Direct',
    subheading: 'If you need help setting up a campaign, consult our experts',
    'title-agency': 'Select a certified advertising agency',
    'title-freelancer': 'Choose a private setup expert',
    'title-yandex': 'Get your ad configured by a Yandex expert'
};
